const ZoomTimelineMixin = {
  data() {
    return {
      zoomPercentage: 100,
      minZoomPercentage: 100,
      maxZoomPercentage: 1000,

      // Target detail maksimum: 1 detik direpresentasikan 5px.
      pixelsPerSecond: 5,

      // Multiplicative zoom configuration.
      maximumZoomFactor: 1.5,
      minimumWheelDelta: 10,
      maximumWheelDelta: 100,

      lastZoomTimestamp: 0,
      zoomThrottleMs: 80,

      isZoomDebouncing: false,
      zoomDebounceTimer: null,
      zoomDebounceMs: 5000,
    }
  },

  computed: {
    countTimeLabel() {
      const baseLabelCount = 8
      const count = Math.round(baseLabelCount * (this.zoomPercentage / 100))

      return Math.max(2, count)
    },
  },

  beforeDestroy() {
    this.clearZoomDebounce()
  },

  methods: {
    startZoomDebounce() {
      this.isZoomDebouncing = true

      if (this.zoomDebounceTimer !== null) {
        window.clearTimeout(this.zoomDebounceTimer)
      }

      this.zoomDebounceTimer = window.setTimeout(() => {
        this.isZoomDebouncing = false
        this.zoomDebounceTimer = null
      }, this.zoomDebounceMs)
    },

    clearZoomDebounce() {
      if (this.zoomDebounceTimer !== null) {
        window.clearTimeout(this.zoomDebounceTimer)
        this.zoomDebounceTimer = null
      }

      this.isZoomDebouncing = false
    },

    calculateMaxZoomPercentage(durationInSeconds, scrollerWidth) {
      if (
        !Number.isFinite(durationInSeconds) ||
        durationInSeconds <= 0 ||
        !Number.isFinite(scrollerWidth) ||
        scrollerWidth <= 0
      ) {
        return this.minZoomPercentage
      }

      const targetContentWidth = durationInSeconds * this.pixelsPerSecond

      return Math.max(this.minZoomPercentage, (targetContentWidth / scrollerWidth) * 100)
    },

    zoomToMaxAtPosition(refsScroller, refsContent, durationInSeconds, positionPercentage) {
      const scroller = refsScroller
      const wrapper = refsContent

      if (!scroller || !wrapper || !scroller.clientWidth) {
        return
      }

      const maximumZoom = this.calculateMaxZoomPercentage(durationInSeconds, scroller.clientWidth)

      this.maxZoomPercentage = maximumZoom
      this.zoomPercentage = maximumZoom

      this.$nextTick(() => {
        const normalizedPosition = Math.min(Math.max(Number(positionPercentage) || 0, 0), 100)
        const markerPixel = wrapper.scrollWidth * (normalizedPosition / 100)
        const maximumScrollLeft = Math.max(wrapper.scrollWidth - scroller.clientWidth, 0)
        const targetScrollLeft = markerPixel - scroller.clientWidth / 2

        scroller.scrollLeft = Math.min(Math.max(targetScrollLeft, 0), maximumScrollLeft)
      })
    },

    getDynamicZoomFactor(deltaY) {
      const absoluteDelta = Math.abs(deltaY)

      const normalizedDelta = Math.min(
        Math.max(absoluteDelta, this.minimumWheelDelta),
        this.maximumWheelDelta
      )

      const wheelStrength = normalizedDelta / this.maximumWheelDelta

      return 1 + (this.maximumZoomFactor - 1) * wheelStrength
    },

    handleTimelineZoom(event, refsScroller, refsContent, durationInSeconds) {
      if (!event || event.deltaY === 0) return

      this.startZoomDebounce()

      const currentTimestamp = Date.now()

      if (currentTimestamp - this.lastZoomTimestamp < this.zoomThrottleMs) {
        return
      }

      const scroller = refsScroller
      const wrapper = refsContent

      if (!scroller || !wrapper || !scroller.clientWidth || !wrapper.scrollWidth) {
        return
      }

      if (Number.isFinite(durationInSeconds) && durationInSeconds > 0) {
        this.maxZoomPercentage = this.calculateMaxZoomPercentage(
          durationInSeconds,
          scroller.clientWidth
        )
      }

      const zoomFactor = this.getDynamicZoomFactor(event.deltaY)
      const isZoomingIn = event.deltaY < 0
      const requestedZoom = isZoomingIn
        ? this.zoomPercentage * zoomFactor
        : this.zoomPercentage / zoomFactor

      const nextZoom = Math.min(
        this.maxZoomPercentage,
        Math.max(this.minZoomPercentage, requestedZoom)
      )

      if (nextZoom === this.zoomPercentage) return

      this.lastZoomTimestamp = currentTimestamp

      const scrollerRect = scroller.getBoundingClientRect()
      const cursorX = Math.min(Math.max(event.clientX - scrollerRect.left, 0), scroller.clientWidth)

      // Posisi waktu di bawah cursor sebelum zoom.
      const currentTimelineX = scroller.scrollLeft + cursorX

      const cursorTimelineRatio = currentTimelineX / wrapper.scrollWidth

      this.zoomPercentage = nextZoom

      this.$nextTick(() => {
        // Posisi waktu yang sama setelah lebar wrapper berubah.
        const newTimelineX = cursorTimelineRatio * wrapper.scrollWidth
        const maximumScrollLeft = Math.max(wrapper.scrollWidth - scroller.clientWidth, 0)
        const targetScrollLeft = newTimelineX - cursorX
        scroller.scrollLeft = Math.min(Math.max(targetScrollLeft, 0), maximumScrollLeft)
      })
    },
  },
}

export default ZoomTimelineMixin
